<div class="file-download-card">
  <span class="file-download-card__icon" aria-hidden="true">
    <ptl-icon [icon]="icon()" size="m"></ptl-icon>
  </span>

  <span class="file-download-card__meta">
    <span class="file-download-card__name" [title]="displayName() ?? ''">
      {{ displayName() ?? (fallbackNameKey | transloco) }}
    </span>
    @if (typeLabel()) {
      <span class="file-download-card__type">{{ typeLabel() }}</span>
    }
  </span>

  <ptl-button
    [icon]="LucideDownload"
    [type]="'primary'"
    [size]="'sm'"
    [ariaLabel]="downloadAriaLabelKey | transloco: { name: displayName() }"
    [text]="downloadLabelKey | transloco"
    (clicked)="download()"
  ></ptl-button>
</div>

@if (caption()) {
  <p class="file-download-card__caption">{{ caption() }}</p>
}
